import { render, staticRenderFns } from "./DynPropUnknownBooleanDetail.vue?vue&type=template&id=4f710ef0"
import script from "./DynPropUnknownBooleanDetail.vue?vue&type=script&lang=js"
export * from "./DynPropUnknownBooleanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports